import {PartnersConnectionsState} from "@/store/settings/partners_connections/types";
import {Module} from "vuex";
import {RootState} from "@/store/types";
import {getters} from "@/store/settings/partners_connections/getters";
import {actions} from "@/store/settings/partners_connections/actions";
import {mutations} from "@/store/settings/partners_connections/mutations";

export const state: PartnersConnectionsState = {
  partnersConnections: [],
};

export const partnersConnections: Module<PartnersConnectionsState,RootState> = {
  state,
  getters,
  actions,
  mutations,
};